import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ItemType } from '@vendasta/marketplace-apps';

@Pipe({
  name: 'displayLabelPipe',
  pure: true,
})
export class DisplayLabelPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(itemType?: ItemType): string {
    if (itemType === ItemType.ITEM_TYPE_APP) {
      return this.translateService.instant('ITEM_SEARCH_SELECT_FILTER.PRODUCT_LABEL');
    } else if (itemType === ItemType.ITEM_TYPE_ADDON) {
      return this.translateService.instant('ITEM_SEARCH_SELECT_FILTER.ADDON_LABEL');
    } else {
      return this.translateService.instant('ITEM_SEARCH_SELECT_FILTER.LABEL');
    }
  }
}
